export default __webpack_public_path__ + "static/media/template_business-man__0008_19---Leon.854afdf6.png";